var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgency(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M12 19.75a.744.744 0 0 1-.53-.22l-3-3a.75.75 0 0 1-.212-.636l1-7a.75.75 0 1 1 1.485.212l-.946 6.629 2.204 2.205 2.204-2.205-.946-6.629a.75.75 0 1 1 1.485-.212l1 7a.75.75 0 0 1-.212.636l-3 3a.748.748 0 0 1-.53.22z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M19 4.25h-.689l-1.78-1.78a.748.748 0 0 0-.53-.22h-8a.744.744 0 0 0-.53.22l-1.78 1.78h-.689A2.752 2.752 0 0 0 2.252 7v12a2.752 2.752 0 0 0 2.75 2.75h14a2.752 2.752 0 0 0 2.75-2.75V7a2.752 2.752 0 0 0-2.75-2.75zm-1.944.866L14.852 8.79l-1.791-1.791L16 4.06zM12 5.939 9.811 3.75h4.379l-2.189 2.189zM8 4.061 10.939 7 9.148 8.791 6.944 5.117zM20.25 19c0 .689-.561 1.25-1.25 1.25H5c-.689 0-1.25-.561-1.25-1.25V7c0-.689.561-1.25 1.25-1.25h.575l2.781 4.636A.746.746 0 0 0 9 10.75a.748.748 0 0 0 .53-.22L12 8.06l2.47 2.47a.75.75 0 0 0 1.174-.144l2.781-4.636H19c.689 0 1.25.561 1.25 1.25z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency);
export default __webpack_public_path__ + "static/media/agency.525f6fe964017c2ea7d0b75a6143e31d.svg";
export { ForwardRef as ReactComponent };